import { jsx as _jsx } from "react/jsx-runtime";
import { Renderer_DataField_Base } from './Renderer_DataField_Base.js';
import { TS_Input, stopPropagation, ModuleFE_Toaster } from '@nu-art/thunderstorm-frontend/index';
import { BadImplementationException, MUSTNeverHappenException, exists, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Expression, ModuleFE_Advisor_Value } from '@app/advisor-frontend';
import { valueType_Range, valueType_StandardRange } from '@app/hcs-shared';
import { ExpressionType_NormalRange } from '@app/hcs-shared/expression';
import { ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
export class Renderer_DataField_Raw extends Renderer_DataField_Base {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.value = nextProps.value;
        state.placeholder = nextProps.placeholder;
        //Calculate value scope
        const parentValue = ModuleFE_Advisor_Value.cache.unique(state.variable.valueId);
        if (!parentValue)
            throw new MUSTNeverHappenException(`Could not get parent value for id ${state.variable.valueId}`);
        const relevantValueTypes = [valueType_StandardRange, valueType_Range];
        if (!relevantValueTypes.includes(parentValue.type))
            throw new BadImplementationException('cannot resolve numeric scope to non numeric value');
        state.valueScope = this.resolveNormalRange(state.variable, parentValue);
        return state;
    }
    //######################### Logic #########################
    resolveNormalRange(variable, parentValue) {
        const relatedNormalRangeExpression = ModuleFE_Advisor_Expression
            .cache.find(expr => expr.associatedVar === variable._id && expr.expressionType === ExpressionType_NormalRange.dbKey);
        if (!relatedNormalRangeExpression)
            return parentValue.data.scope ?? parentValue.data.fullRange;
        const rangeFinding = sortArray(ModuleFE_RuntimeFinding.cache.filter(finding => finding.variableId === relatedNormalRangeExpression._id), f => f.__created, true)[0];
        return rangeFinding.value;
    }
    onValue = (_value) => {
        if (!_value)
            return this.props.onValue();
        const value = Number(_value);
        if (isNaN(value))
            return ModuleFE_Toaster.toastError('Invalid numeric value');
        this.props.onValue(value);
    };
    getPlaceholder = () => {
        if (this.state.placeholder)
            return { text: this.state.placeholder, highlight: true };
        const scope = this.state.valueScope;
        if (!exists(scope[0]) || !exists(scope[1]))
            return { text: 'Unknown', highlight: false };
        return { text: `${String(scope[0])} - ${String(scope[1])}`, highlight: false };
    };
    //######################### Render #########################
    render_DataIntake = () => {
        const value = exists(this.state.value) ? String(this.state.value) : undefined;
        const placeholder = this.getPlaceholder();
        return _jsx(TS_Input, { type: 'number', disabled: this.state.disabled, value: value, className: placeholder.highlight ? 'highlight' : undefined, onBlur: this.onValue, placeholder: placeholder.text, onClick: e => stopPropagation(e) });
    };
}
//# sourceMappingURL=Renderer_DataField_Raw.js.map